import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

import App from './App.jsx';
import Login from './routes/Login.jsx';
import MyDay from './routes/MyDay.jsx';
import Equipment from './routes/Equipment.jsx';
import EquipmentDetail from './routes/EquipmentDetail.jsx';
import EquipmentNew from './routes/EquipmentNew.jsx';
import ServiceCalendar from './routes/ServiceCalendar.jsx';
// pdf.js is large — only load it when someone actually opens a manual
const ManualViewer = lazy(() => import('./routes/ManualViewer.jsx'));
import Receipts from './routes/Receipts.jsx';
import ReceiptNew from './routes/ReceiptNew.jsx';
import Reimbursements from './routes/Reimbursements.jsx';
import Income from './routes/Income.jsx';
import IncomeNew from './routes/IncomeNew.jsx';
import Cattle from './routes/Cattle.jsx';
import CattleNew from './routes/CattleNew.jsx';
import CattleDetail from './routes/CattleDetail.jsx';
import CattleImport from './routes/CattleImport.jsx';
import Chickens from './routes/Chickens.jsx';
import ChickensNew from './routes/ChickensNew.jsx';
import ChickensDetail from './routes/ChickensDetail.jsx';
import Chores from './routes/Chores.jsx';
import ChoreNew from './routes/ChoreNew.jsx';
import Projects from './routes/Projects.jsx';
import ProjectNew from './routes/ProjectNew.jsx';
import ProjectDetail from './routes/ProjectDetail.jsx';
import USDA from './routes/USDA.jsx';
import Reports from './routes/Reports.jsx';
import Contractors from './routes/Contractors.jsx';
import Transactions from './routes/Transactions.jsx';
import Reconcile from './routes/Reconcile.jsx';
import Settings from './routes/Settings.jsx';
import QuickIncome from './routes/QuickIncome.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<App />}>
          <Route index element={<Navigate to="/my-day" replace />} />
          <Route path="my-day" element={<MyDay />} />
          <Route path="equipment" element={<Equipment />} />
          <Route path="equipment/new" element={<EquipmentNew />} />
          <Route path="equipment/:id" element={<EquipmentDetail />} />
          <Route path="equipment/:id/edit" element={<EquipmentNew />} />
          <Route path="calendar" element={<ServiceCalendar />} />
          <Route path="manuals/:id" element={<Suspense fallback={<div className="text-ink-700/60 italic">Opening manual…</div>}><ManualViewer /></Suspense>} />
          <Route path="receipts" element={<Receipts />} />
          <Route path="receipts/new" element={<ReceiptNew />} />
          <Route path="reimbursements" element={<Reimbursements />} />
          <Route path="income" element={<Income />} />
          <Route path="income/new" element={<IncomeNew />} />
          <Route path="cattle" element={<Cattle />} />
          <Route path="cattle/new" element={<CattleNew />} />
          <Route path="cattle/import" element={<CattleImport />} />
          <Route path="cattle/:id" element={<CattleDetail />} />
          <Route path="chickens" element={<Chickens />} />
          <Route path="chickens/new" element={<ChickensNew />} />
          <Route path="chickens/:id" element={<ChickensDetail />} />
          <Route path="chores" element={<Chores />} />
          <Route path="chores/new" element={<ChoreNew />} />
          <Route path="chores/:id/edit" element={<ChoreNew />} />
          <Route path="projects" element={<Projects />} />
          <Route path="projects/new" element={<ProjectNew />} />
          <Route path="projects/:id" element={<ProjectDetail />} />
          <Route path="projects/:id/edit" element={<ProjectNew />} />
          <Route path="usda" element={<USDA />} />
          <Route path="reports" element={<Reports />} />
          <Route path="contractors" element={<Contractors />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="reconcile" element={<Reconcile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="quick/income" element={<QuickIncome />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
